import { OrganizationKeyName } from "../../../model/Organization";

export const GET_PRODUCT_ADDITION_LIST = "SHOP:GET_PRODUCT_ADDITION_LIST";

export const getProductAdditionListAction = (
  organization: OrganizationKeyName
) => ({
  type: GET_PRODUCT_ADDITION_LIST as typeof GET_PRODUCT_ADDITION_LIST,
  organization,
});

export type GetProductAdditionListAction = ReturnType<
  typeof getProductAdditionListAction
>;
